import axios from 'axios';
import Form from '../../sales/addSale/components/Form.vue';
import List from '../../sales/addSale/components/List.vue';

export default {
  components: { Form, List },
  props: ['id'],
  data() {
    return {
      addedProducts: [],
      object: {
        id: null,
        name: '',
        address: '',
        direction_id: null,
        stage_id: null,
        positions: [],
      },
      documents: [],
      document: {
        base64: '',
        name: '',
        filename: '',
        url: '',
      },


      rules: {
        required: v => !!v || 'Поле должно быть заполнено',
      },
      valid: true,
      profile: {},
      searchPoint: '',
      searchAddress: '',
      pointName: null,
      suggestions: [],
      isLoadingSuggest: false,
      destinations: [],
      stages: [],
      points: [],
      addresses: [],
    };
  },
  watch: {
    searchAddress(address) {
      const app = this;
      const data = {};
      if (app.pointName) {
        data.name = app.pointName;
        data.city_id = app.user.city_id;
        if (address) {
          data.address = address;
        }
        this.$store.getters.ax.post('profiles/api/register/load-dealer-addresses', data)
          .then((result) => {
            this.addresses = result.data.addresses;
          });
      }
    },
    settings() {
      return this.$store.state.settings;
    },
  },
  computed: {
    loading() {
      return this.$store.state.loading;
    },
    user() {
      return this.$store.state.user;
    },
    isManager() {
      return this.$store.getters.isManager;
    },
    categoriesList() {
      return this.$store.state.sales.categoriesList || [];
    },
    isNewSale() {
      return this.$props.id === 'null';
    },
    isNewObject() {
      return this.$props.id === 'null';
    },
    objectId() {
      return this.$props.id;
    },
    btnTitle() {
      return (this.$props.id === 'null' ? 'Зарегистрировать объект' : 'Сохранить объект');
    },
  },
  methods: {
    AddProduct(product) {
      this.addedProducts.push(product);
    },
    /**
     * Удаленгие товара из списка
     * @param {string} idx - индекс удаляемого товара
     */
    RemoveProduct(idx) {
      this.addedProducts = this.addedProducts.filter(p => p.idx !== idx);
    },
    /** Фокус на указанное поле */
    Focus(id) {
      this.$nextTick(() => {
        document.getElementById(id).focus();
      });
    },
    /** Сброс полей формы */
    Reset() {
      this.user = {
        phone: '',
        first_name: '',
        last_name: '',
        middle_name: '',
        email: '',
        password: '',
        passwordConfirm: '',
        dealer_id: '',
        role: 'seller',
        city_id: null,
        checkedRules: false,
        checkedPers: false,
        allow_push: false,

      };
      this.sentCode = false;
      this.code = '';
      this.token = null;
      this.dialogRules = false;
      this.dialogPers = false;
      this.cities = [];
      this.searchPoint = '';
      this.points = [];
      this.pointName = null;
      this.searchAddress = '';
      this.addresses = [];
      this.addedProducts = [];

      this.Focus('regPhone');
    },
    GetFilePath(item) {
      if (item.base64 || item.url) {
        return item.url ? item.url : item.base64;
      }
      return '';
    },
    /** Прикрепить документ. */
    PickDocument() {
      this.$refs.document.click();
    },
    OnDocument(e) {
      this.OnFilePicked(e);
    },
    /**
     * Добавление документа к продаже.
     * @param e эвент
     */
    OnFilePicked(e) {
      const app = this;
      const { files } = e.target;
      if (files[0] !== undefined) {
        const [file] = files;
        if (file.name.lastIndexOf('.') <= 0) {
          return;
        }
        app.document.name = file.name;

        const fr = new FileReader();
        fr.readAsDataURL(file);
        fr.addEventListener('load', () => {
          app.document.filename = null;
          app.document.id = null;
          app.document.base64 = fr.result;
          app.documents.push(app.document);
          app.document = { filename: '', base64: '', name: '', url: '', id: null };
          app.$forceUpdate();
        });
      } else {
        app.document = { filename: '', base64: '', name: '', url: '', id: null };
      }
    },
    /**
     * Удаление документа из списка прикрепленных файлов.
     * @param item объект прикрепленного файла.
     * @param index номер в списке документов.
     */
    deleteFile(item, index) {
      item.name === this.documents[index].name && this.documents.splice(index, 1);
      this.$refs.document.value = '';
      if (!/safari/i.test(navigator.userAgent)) {
        this.$refs.document.type = '';
        this.$refs.document.type = 'file';
      }
    },
    /**
     * Проверка типа документа.
     * @param item {Object} объект документа.
     * @returns {*|boolean}
     */
    CheckPDF(item) {
      if (item.base64) {
        return (item.base64.indexOf('/pdf;') !== -1);
      }
      if (item.url) {
        return (item.url.indexOf('.pdf') !== -1);
      }
      return false;
    },

    /** Отправка регистрационных данных в приложение */
    Register() {
      const app = this;
      app.object.positions = this.addedProducts.map((p, idx) => ({
        position: idx + 1,
        category_id: p.category.id,
        product_id: p.product.id,
        coating_id: p.coating ? p.coating.id : null,
        qty: p.qty,
      }));
      const formData = { ...app.object };
      formData.profile_id = this.user.profile_id;

      formData.documents = app.documents.map(item => ({ name: item.name, base64: item.base64 }));

      const url = !this.isNewObject ? 'objects/api/objects/update' : 'objects/api/objects/create';

      app.$store.getters.axl.post(url, formData)
        .then(() => {
          app.$store.dispatch('ShowInfo', 'Объект зарегистрирован!');
          app.$router.push('/objects');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
    async GetDestinations() {
      const app = this;
      app.$store.getters.ax.post('objects/api/objects/destinations')
        .then((result) => {
          app.destinations = result.data.destinations;
        });
    },
    async GetStages() {
      const app = this;
      app.$store.getters.ax.post('objects/api/objects/stages')
        .then((result) => {
          app.stages = result.data.stages;
        });
    },
    AutocompleteSearch(queryString, cb) {
      if (!queryString) return;
      const app = this;
      const info = { count: 20, query: queryString };
      const config = {
        headers: {
          Accept: 'application/json, text/javascript, */*; q=0.01',
          Authorization: 'Token 7a77efb8ab6dae6e380c7e438b85360185660f34',
          'Content-Type': 'application/json',
        },
      };

      axios.post('https://dadata.ru/api/v2/suggest/address', info, config)
        .then((res) => {
          app.suggestions = res.data.suggestions;
          cb(app.suggestions);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    AutocompleteSelect(item) {
      this.suggestions.forEach((sug) => {
        if (sug.value === item.value) {
          this.address_data = sug.data;
        }
      });
    },
    toDataUrl(url, callback) {
      const xhr = new XMLHttpRequest();
      xhr.onload = () => {
        console.log('onload');
        const reader = new FileReader();
        reader.onloadend = () => {
          console.log('onloadend');
          callback(reader.result);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.open('GET', url);
      xhr.responseType = 'blob';
      xhr.send();
      console.log('open');
    },
    loadFile(name, url) {
      console.log(url);
      this.toDataUrl(url, (myBase64) => {
        console.log(myBase64);
        const app = this;
        app.document.name = name;
        app.document.filename = null;
        app.document.id = null;
        app.document.base64 = myBase64;
        app.documents.push(app.document);
        app.document = { filename: '', base64: '', name: '', url: '', id: null };
        app.$forceUpdate();
      });
    },
    EditObjectPrepare(object) {
      this.object.id = object.id;
      this.object.name = object.name;
      this.object.address = object.name;
      this.object.direction_id = object.destination.id;
      this.object.stage_id = object.stage.id;
      this.addedProducts = object.sale_positions.map(p => ({
        product: p.product,
        category: p.product.category,
        bonuses: p.bonuses,
        qty: p.qty,
      }));
      const app = this;
      object.documents.forEach((p) => {
        app.loadFile(p.name, p.url);
      });
    },
  },
  created() {
    if (this.isManager) {
      this.$router.push('/dashboard');
    } else {
      !this.categoriesList.length && this.$store.dispatch('sales/GetCategories');
    }
  },
  mounted() {
    if (this.$store.state.settings.extranet === true) {
      this.$router.push('/');
    }
    this.$store.dispatch('GetSettings');
    this.GetDestinations();
    this.GetStages();
    if (!this.isNewObject) {
      this.$store.getters.ax.post('objects/api/objects/view', {
        id: this.objectId,
      })
        .then((result) => {
          this.EditObjectPrepare(result.data.object);
        });
    }
  },
};
